import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { DatabaseProvider } from './context/DatabaseContext'; // Import the DatabaseProvider
import Kernteamportal from './Kernteamportal'; // Import the Kernteamportal component
import ProtectedRoute from './ProtectedRoute';
import JobsKinder from './arbeit/jobskinder/JobsKinder'; // Import the JobsKinder component
import JobsMarkieren from './arbeit/jobsmarkieren/JobsMarkieren'; // Import the JobsMarkieren component
import Kinderverwaltung from './arbeit/kinderverwaltung/Kinderverwaltung'; // Import the Kinderverwaltung component
import JobsVerwaltung from './arbeit/jobsverwaltung/JobsVerwaltung'; // Import the JobsVerwaltung component
import JobsZuteilen from './arbeit/jobszuteilen/JobsZuteilen'; // Import the JobsZuteilen component
import Finanzamt from './listen/finanzamt/finanzamt'; // Import the Finanzamt component
import Wahlkreis from './listen/wahlkreis/wahlkreis'; // Import the Wahlkreis component
import DienstplaenePage from './listen/dienstplaene/DienstplaenePage'; // Import the DienstplaenePage component
import SelbststaendigkeitAuslesen from './listen/selbststaendigkeit/SelbststaendigkeitAuslesen'; // Import the SelbststaendigkeitAuslesen component
import Sparkasse from './listen/sparkasse/sparkasse';
import JobsHinzufuegen from './arbeit/jobshinzufuegen/JobsHinzufuegen'; // Import the JobsHinzufuegen component
import JobBearbeiten from './arbeit/jobsverwaltung/JobBearbeiten';
import FreizeitHinzufuegen from './freizeit/freizeithinzufuegen/FreizeitHinzufuegen';
import FreizeitMarkieren from './freizeit/freizeitmarkieren/FreizeitMarkieren';
import FreizeitVerwaltung from './freizeit/freizeitverwaltung/FreizeitVerwaltung';
import Freizeit from './freizeit/Freizeit'; // Import the Freizeit component
import Arbeit from './arbeit/Arbeit'; // Import the Arbeit component
import EinheitenAktivieren from './arbeit/einheitenaktivieren/EinheitenAktivieren';
import KindSpezialwunsch from './arbeit/kind_spezialwunsch/KindSpezialwunsch'; // Platzhalter
import KindSaltyScore from './arbeit/kind_saltyscore/KindSaltyScore'; // Platzhalter
import KindHinzufuegen from './arbeit/kindhinzufuegen/Kindhinzufuegen';
import Listen from './listen/Listen';
import SpeiseplanVerwaltung from './listen/speiseplan/SpeiseplanVerwaltung';
import EssensreihenfolgeVerwaltung from './listen/essensreihenfolge/EssensreihenfolgeVerwaltung';
import TagesablaufVerwaltung from './listen/tagesablauf/TagesablaufVerwaltung';
import Kinder from './kinder/Kinder';
import Stadtplan from './stadtplan/Stadtplan';

import DisplaySteuerung from './arbeit/displaysteuerung/DisplaySteuerung';
import AusschussVerwaltung from './parlament/AusschussVerwaltung';
import Logistik from './logistik/Logistik';
import Schichtplan from './logistik/schichtplan/Schichtplan';
import Fahrten from './logistik/fahrten/Fahrten';
import Inventar from './logistik/inventar/Inventar';

export const host_url = process.env.REACT_APP_API_URL || "";
export const kernteam_password = process.env.REACT_APP_KERNTEAM_PASSWORD || 'default_password';
// Zentrale Adresse des Stormini-Portals. Im Camp-Intranet zeigt
// stormini-portal.de per DNS-Override auf den lokalen Server.
export const portal_url = process.env.REACT_APP_PORTAL_URL || "http://stormini-portal.de";

function App() {

  return (
    <DatabaseProvider> {/* Wrap the application in the DatabaseProvider */}
      <Router>
        <Routes>
          <Route path="/kernteamportal" element={<Kernteamportal />} />

          <Route
            path="/jobs_kinder"
            element={
              <ProtectedRoute>
                <JobsKinder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobsmarkieren"
            element={
              <ProtectedRoute>
                <JobsMarkieren />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kinderverwaltung"
            element={
              <ProtectedRoute>
                <Kinderverwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobsverwaltung"
            element={
              <ProtectedRoute>
                <JobsVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobszuteilen"
            element={
              <ProtectedRoute>
                <JobsZuteilen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/finanzamt"
            element={
              <ProtectedRoute>
                <Finanzamt />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/wahlkreis"
            element={
              <ProtectedRoute>
                <Wahlkreis />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/sparkasse"
            element={
              <ProtectedRoute>
                <Sparkasse />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/dienstplaene"
            element={
              <ProtectedRoute>
                <DienstplaenePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/selbststaendigkeit"
            element={
              <ProtectedRoute>
                <SelbststaendigkeitAuslesen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/speiseplan"
            element={
              <ProtectedRoute>
                <SpeiseplanVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/essensreihenfolge"
            element={
              <ProtectedRoute>
                <EssensreihenfolgeVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen/tagesablauf"
            element={
              <ProtectedRoute>
                <TagesablaufVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/jobs_hinzufuegen"
            element={
              <ProtectedRoute>
                <JobsHinzufuegen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/job_bearbeiten"
            element={
              <ProtectedRoute>
                <JobBearbeiten />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeithinzufuegen"
            element={
              <ProtectedRoute>
                <FreizeitHinzufuegen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeitmarkieren"
            element={
              <ProtectedRoute>
                <FreizeitMarkieren />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeitverwaltung"
            element={
              <ProtectedRoute>
                <FreizeitVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/freizeit"
            element={
              <ProtectedRoute>
                <Freizeit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/arbeit"
            element={
              <ProtectedRoute>
                <Arbeit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kinder"
            element={
              <ProtectedRoute>
                <Kinder />
              </ProtectedRoute>
            }
          />
          <Route
            path="/einheiten-aktivieren"
            element={
              <ProtectedRoute>
                <EinheitenAktivieren />
              </ProtectedRoute>
            }
          />
          <Route
            path="/display-steuerung"
            element={
              <ProtectedRoute>
                <DisplaySteuerung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/listen"
            element={
              <ProtectedRoute>
                <Listen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kind_spezialwunsch"
            element={
              <ProtectedRoute>
                <KindSpezialwunsch />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kind_saltyscore"
            element={
              <ProtectedRoute>
                <KindSaltyScore />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kindhinzufuegen"
            element={
              <ProtectedRoute>
                <KindHinzufuegen />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stadtplan"
            element={
              <ProtectedRoute>
                <Stadtplan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/parlament/ausschuesse"
            element={
              <ProtectedRoute>
                <AusschussVerwaltung />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logistik"
            element={
              <ProtectedRoute>
                <Logistik />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logistik/schichtplan"
            element={
              <ProtectedRoute>
                <Schichtplan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logistik/fahrten"
            element={
              <ProtectedRoute>
                <Fahrten />
              </ProtectedRoute>
            }
          />
          <Route
            path="/logistik/inventar"
            element={
              <ProtectedRoute>
                <Inventar />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Kernteamportal />} /> {/* Default route */}
        </Routes>
      </Router>
    </DatabaseProvider>
  );
}

export default App;